import { Link } from 'react-router-dom';
import TerminateService from '../../../src/assets/images/terminate-service.svg';
import Unsubscribing from '../../../src/assets/images/unsubscribing.svg';
import TopPageBack from '../../components/TopPageBack';
import { CEO_TYPES } from '../../constants/AppConstants';
import { ROUTE_PATHS } from '../../constants/Router';
import useAuth from '../../hooks/useAuth';
import { useState, useEffect } from 'react';
import { store, dispatch, useDispatch } from '../../store';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateCeoStatus } from '../../actions/CeoStatus';
import CeoApi from '../../apis/ceo.api';

const DeleteAccount = function () {
  const { ceoInfo } = useAuth();
  const [isPremiumDeleted, setIsPremiumDeleted] = useState(false);
  const [isAccountDeleted, setIsAccountDeleted] = useState(false);

  const location = useLocation();
  const { state } = location;

  const getCeoStatus = async () => {
    if (ceoInfo?.ceo_idx) {
      const response = await CeoApi.getDeleteStatus(ceoInfo?.ceo_idx);
      if (response.data.data) {
        setIsPremiumDeleted(response.data.data['canceledPremium']);
        setIsAccountDeleted(response.data.data['isDeleted']);
        await dispatch(updateCeoStatus(response.data.data));
      }
    }
  };

  useEffect(() => {
    if (state?.refresh) {
      getCeoStatus();
    } else {
      setIsPremiumDeleted(store.getState().CeoStatus['canceledPremium']);
      setIsAccountDeleted(store.getState().CeoStatus['isDeleted']);
    }
  }, []);

  const handleKakaoTalkInquiry = () => {
    window.open('https://pf.kakao.com/_Jjlxoxj/chat', '_blank');
  };

  return (
    <div>
      <TopPageBack>
        <b>탈퇴하기</b>
      </TopPageBack>
      <div className='h-4'></div>
      <div className='mx-2'>
        {ceoInfo?.ceo_type === CEO_TYPES.PREMIUM && (
          <div className='review-card2 py-4 flex flex-col'>
            <div className='icon-wrapper'>
              <img src={TerminateService} />
            </div>
            <div className='flex flex-col gap-2'>
              <b className='text-lg'>프리미엄 서비스 해지</b>
              <span>
                유료 서비스 이용 해지를 원하시는 경우,
                <br />
                <b>카카오톡 채널 '스폰지R_가맹점'</b>으로 문의하시거나
                <br />
                <b>050-7964-1000</b>으로 전화해 주세요.
                <br />
                확인 후 해지 절차를 안내해 드리겠습니다.
              </span>
            </div>

            <button className='w-full outline-blue-btn mt-5 text-appblue' onClick={handleKakaoTalkInquiry}>
              카카오톡 문의하기
            </button>

            {/* <Link
              to={isPremiumDeleted ? ROUTE_PATHS.CancelPremiumDeleteRequest : ROUTE_PATHS.PremiumServiceManagement}
              className='w-full outline-blue-btn mt-5 text-appblue'>
              {isPremiumDeleted ? '프리미엄 서비스 해지 취소' : '프리미엄 서비스 관리'}
            </Link> */}
          </div>
        )}

        <div className='review-card2 py-4 flex flex-col'>
          <div className='icon-wrapper'>
            <img src={Unsubscribing} />
          </div>
          <div className='flex flex-col gap-2'>
            <b className='text-lg'>서비스 탈퇴</b>
            <span>
              서비스 탈퇴 시 가맹점의 모든 계정 정보가 삭제되어 복구할 수 없어요.
              <br />
              탈퇴 후에는 정보 복구가 어려우니 탈퇴를 원하시는 경우,
              <br />
              <b>카카오톡 채널 "스폰지R_가맹점"</b>으로 문의주시거나
              <br />
              고객센터 <b>050-7964-1000</b>으로 전화해 주세요.
            </span>
          </div>
          <Link to={isAccountDeleted ? ROUTE_PATHS.CancelDeleteAccount : ROUTE_PATHS.DeleteAccountDetails} className='w-full outline-red-btn mt-5'>
            {isAccountDeleted ? '탈퇴 취소' : '서비스 탈퇴'}
          </Link>
        </div>
      </div>
    </div>
  );
};
export default DeleteAccount;
